import { MarkdownDocs } from '@mui/internal-core-docs/MarkdownDocs';
import * as pageProps from 'docs/data/date-pickers/lifecycle/lifecycle.md?muiMarkdown';

export default function Page() {
  return <MarkdownDocs {...pageProps} />;
}
